// extracted by mini-css-extract-plugin
export default {"ExtraRender":"ExtraRender_ExtraRender__bL++W"};